import React, {useState} from "react";
import {Modal} from "../../Modal";
import {useModalContext} from "../../../contexts/ModalContext/context";
import {Button} from "../../../UI/Button";
import {Form} from "semantic-ui-react";
import {Box} from "../../../UI/Box";
import {CreatePortfolioLifestyleTemplate, PortfolioLifestyleTemplate} from "../../../services/PortfolioApi";
import useAuth from "../../../routes/login/AuthContext";
import {ErrorResponse} from "../../../services/Common";

interface TemplateCreationModalProps {
    portfolioId: string;
    addTemplate: (template: PortfolioLifestyleTemplate) => void;
}

export const TemplateCreationModal: React.FC<TemplateCreationModalProps> = ({portfolioId, addTemplate}) => {
    const {setIsOpen} = useModalContext();
    const {getAuthToken} = useAuth();
    const [templateName, setTemplateName] = useState<string>("");
    const [error, setError] = useState<boolean>(false);


    const onHide = () => {
        setIsOpen(false);
    };


    const onSubmit = async () => {
        if (validateFields()) {
            let template = await CreatePortfolioLifestyleTemplate(templateName, portfolioId, await getAuthToken());
            if (template && !(template instanceof ErrorResponse)) {
                addTemplate(template);
                onHide();
            }
        }
    };

    const validateFields = () => {
        setError(templateName !== "");
        return templateName !== "";
    };

    return (

        <Modal
            title="Create Template"
            onClose={onHide}
            actions={
                <>
                    <Button appearance="danger" onClick={onHide}>
                        Cancel
                    </Button>
                    <Button onClick={onSubmit}>
                        Create Template
                    </Button>
                </>
            }
        >
            <Box px={3} py={2}>
                <Form error={error}>
                    <Form.Field error={error}>
                        <label>Template Name</label>
                        <input
                            placeholder="Template Name"
                            onChange={(event) => {
                                setTemplateName(event.target.value);
                            }}
                        />
                    </Form.Field>
                </Form>
            </Box>
        </Modal>
    );
};